import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { track } from 'components/Services/Analytics/AnalyticsService';
import ShippingAddressDialog from './ShippingAddressDialog';
import RestAPI from '../../../Common/restApi';

const MojioShippingAddressCard = ({open = true, isOpen = true, onCancel, dialogTitle, invalid }) => {
  const dispatch = useDispatch();

  const saveShippingAddress = (values) =>
    new Promise((resolve, reject) => {
      dispatch(
        track('Click', {
          button_name: 'shipping address entered',
          app_name: 'vehicle_gps_tracking',
          pathname: '/pro/apps/details/vehicle_gps_tracking',
        })
      );

      const promise = RestAPI.updateWithFormData('/alpha/mojio/shipping_address', {
        shipping_address: values,
      });

      promise.then(() => {
        resolve();
      }, reject);

      promise.catch(reject);

      return promise;
    });

  return (
    <div>
      <ShippingAddressDialog
      open={open}
      isOpen={isOpen}
      onSubmit={saveShippingAddress}
      onCancel={onCancel}
      dialogTitle={dialogTitle}
      invalid={invalid}
      />
    </div>
  );
};

MojioShippingAddressCard.propTypes = {
  open: PropTypes.bool,
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func,
  dialogTitle: PropTypes.string,
  invalid: PropTypes.bool
}

export default MojioShippingAddressCard;
